export default function Steps (){
   
   
    return (
        <div className="container--big-row">
        <div className="steps-container">
        <figure className="content--img-container"><img  src="undraw_secure_login_pdn4.svg"/></figure>
        <div className="content--description">
            <h3 className="content-section--2title special-color content--text-right">STEPS</h3>
            <h1 className="content-section--1title content--text-right">Your Journey to Online Success <span className="special-color-1">Begins Here.</span></h1>
           <div className="steps--list">
            <div className="steps--content">
               <h1 className="steps--num">01</h1>
                <div className="steps--group"> 
                    <h2 className="steps--title">Choose Your Hosting Plan</h2>
                    <p className="steps--para">Plan Browse through our range of hosting plans tailored to suit various needs and budgets. From shared hosting for beginners to dedicated servers for advanced users, we've got the perfect plan for you. Compare features and select the plan that aligns with your goals.</p>
                </div>
                
            </div>
            <div className="steps--content">
                <h1 className="steps--num">02</h1>
                <div className="steps--group"> 
                    <h2 className="steps--title">Select a Domain Name </h2>
                    <p className="steps--para">If you don't already have a domain name, it's time to choose one! Your domain is your online identity, so make it memorable and relevant to your website's content. You can register a new domain or transfer an existing one to us.</p>
                </div>
                
            </div>
            <div className="steps--content">
                <h1 className="steps--num">03</h1>
                <div className="steps--group"> 
                    <h2 className="steps--title">Place Your Order </h2>
                    <p className="steps--para">Once you've decided on your hosting plan and domain name, proceed to our secure checkout process. Review your order and provide the necessary information. Rest assured, your payment and personal details are safe with us.</p>
                </div>
                
            </div>
            <div className="steps--content">
                <h1 className="steps--num">04</h1>
                <div className="steps--group"> 
                    <h2 className="steps--title">Set Up Your Hosting Account </h2>
                    <p className="steps--para">After payment, you'll receive a confirmation email with your account details and login credentials. Use these credentials to access your hosting control panel, where you can manage your website, emails, databases, and more.</p>
                </div>
                
            </div>
           </div>
        </div>

        </div>
        </div>
        
        )
}